// 9fbef606107a605d69c0edbcd8029e5d
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';

// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_LABELS = 'global';
export const SEARCH_BAR_LABELS = `${GLOBAL_LABELS}.Search`;

// Search
export const lblSearchWhatsTrending = `lbl_search_whats_trending`;
export const lblSearchRecentSearch = `lbl_search_recent_search`;
export const lblSearchLookingFor = `lbl_search_looking_for`;
export const lblSearchProductMatches = `lbl_search_product_matches`;
export const lblCategoryMatches = `lbl_category_matches`;
export const lblWhatLookingFor = `lbl_what_looking_for`;
export const lblClearRecentSearch = `lbl_clear_recent_search`;
export const lblPopularSearch = `lbl_popular_search`;
export const lblHomepageFeaturePromotions = `lbl_hompage_featured_promotions`;
export const lblYouMayLike = `lbl_you_may_like`;

export const SearchBarLabels = {
  global: {
    Search: {
      [lblSearchWhatsTrending]: "WHAT'S TRENDING",
      [lblSearchRecentSearch]: 'YOUR RECENT SEARCHES',
      [lblSearchLookingFor]: 'I AM LOOKING FOR',
      [lblSearchProductMatches]: 'TOP MATCHING PRODUCTS',
      [lblCategoryMatches]: 'CATEGORY MATCHES',
      [lblWhatLookingFor]: 'What are you looking for?',
      [lblClearRecentSearch]: 'CLEAR ALL',
      [lblPopularSearch]: 'POPULAR SEARCHES',
      [lblHomepageFeaturePromotions]: 'Featured Promotions',
      [lblYouMayLike]: 'YOU MAY LIKE',
    },
  },
};

export function getSearchBarLabels() {
  return getLabelFromCopyOrFromTranslation(SEARCH_BAR_LABELS, SearchBarLabels);
}
